module.exports = __webpack_public_path__ + "img/fishing.cf52246f.svg";